import React from 'react'
import PropTypes from 'prop-types'
import tw, { css, styled } from 'twin.macro'

import Layout from '../../components/layout'
import Meta from '../../components/meta'
import { graphql } from 'gatsby'
import axios from 'axios'
import qs from 'qs'
import filterLocale from '../../components/utils/filter-locale'
import SupportSearch from '../../components/support/support-search'
import Tabs from '../../components/support/tabs'
import PopUp from '../../components/modal/forms'
import {
	StyledForm,
	HomeButtonRow,
	HomeButton,
} from '../../components/form/styles'
import { Formik } from 'formik'
import assign from 'lodash.assign'
import {
	flat,
	validationSwitch,
	validationSchema,
} from '../../components/form/utils'
import FormFieldGroup from '../../components/form/FormFieldGroup'
import FormFieldSingle from '../../components/form/FormFieldSingle'
import {
	ButtonRow,
	Button,
	Input,
	Select,
	Textarea,
	SelectIcon,
	SelectWrap,
	StyledCheckBox,
	FieldSet,
	FieldRow,
	FieldWrap,
	Legend,
	Label,
	StyledError,
	StyledHelp,
	Required,
	StyledComboboxInput,
} from '../../components/form/styles'
import { Lottie } from '@lottie'
import { Field } from 'formik'
import { CustomCheckboxContainer, CustomCheckboxInput } from '@reach/checkbox'
import * as animationCheckbox from '../../animations/checkbox.json'

const ContentsSection = tw.section`w-full bg-gray-200 pt-20`
const ContentsContainer = tw.div`w-95 md:w-11/12 bg-white py-10 px-4 md:px-10 mx-auto border-l border-r border-gray-300 border-b rounded mb-16`

const ContactContainer = tw.div`flex flex-col items-center justify-center`
const ContactTitle = tw.h3`font-display text-5xl md:text-6xl text-gray-700 font-bold text-center mb-3 md:mb-0`
const ContactDescription = tw.p`font-display text-lg mb-6 md:mb-12 text-gray-700 text-center`

const AcceptTerms = tw.div`flex w-full md:w-1/2 my-4 items-center text-base`
const PolicyButton = tw.a`px-2 py-1 my-2 bg-gray-700 hover:bg-gray-800 text-white rounded`

const CheckboxContainer = styled(CustomCheckboxContainer)`
	${tw`flex items-center justify-center`}
	input {
		${tw`border-0 p-0 h-px w-px -m-px absolute overflow-hidden whitespace-nowrap `}
		clip: rect(0 0 0 0);
		clippath: inset(50%);
	}
`

const BecomeADealer = ({ data: { page, form } }) => {
	const [showDialog, setShowDialog] = React.useState(false)
	const open = () => setShowDialog(true)
	const close = () => setShowDialog(false)
	const locale = 'en-AU'
	const [{ node: pageNode }] = filterLocale(page.edges, locale)

	const [{ node: formNode }] = filterLocale(form.edges, locale)
	const {
		title: formTitle,
		description: formDescription,
		endpoint: formEndpoint,
		items: formItems,
	} = formNode

	const { seoTitle, seoKeywords, seoDescription, slug, body } = pageNode

	const valuesMapped = flat(formItems).map(item => ({
		[item.inputName]: '',
	}))
	valuesMapped.push({ policy: false })
	valuesMapped.push({ readandagree: false })
	const validationMapped = flat(formItems).map(item => ({
		[item.inputName]: validationSwitch(item.inputName, item.validationText),
	}))
	validationMapped.push({ policy: validationSwitch('policy') })
	validationMapped.push({ readandagree: validationSwitch('readandagree') })
	/** New Object from mapped Array */
	const valuesObject = assign({}, ...valuesMapped)
	const validationObject = assign({}, ...validationMapped)
	// const [sendForm, { loading, error, data }] = useMutation(SEND_FORM)
	
	return (
		<Layout>
			<Meta
				title={seoTitle}
				keywords={seoKeywords}
				description={seoDescription}
			/>
			<SupportSearch />
			{/* <Tabs /> */}
			<ContentsSection>
				<ContentsContainer>
					<ContactContainer>
						<ContactTitle>{formTitle}</ContactTitle>
						<ContactDescription>{formDescription}</ContactDescription>
						<Formik
							initialValues={valuesObject}
							validationSchema={validationSchema(validationObject)}
							onSubmit={async (values, { setSubmitting, resetForm }) => {
								setSubmitting(true)
								const url =
									'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8'
								const body = {
									'00N4H00000EOB08': values.abn,
									company: values.company,
									email: values.email,
									first_name: values.firstName,
									last_name: values.lastName,
									lead_source: 'Website',
									oid: '00D58000000JkgU',
									phone: values.phone,
									recordType: '0124H000000QkWKQA0',
									retURL:
										'https://maytronics.com.au/support/become-a-dealer/?form=become-a-dealer',
									street: values.streetAddress,
									city: values.city,
									state: values.state,
									zip: values.postCode,
									country: 'Australia',
									'00N4H00000EBmQp': 'MTAU',
									url: 'https://maytronics.com.au/support/become-a-dealer',
								}
								axios.post(url, qs.stringify(body))
								// axios.post('/.netlify/functions/graphql', {
								// 	query: `
								// 			mutation createForm(
								// 				$formName: String!
								// 				$firstName: String
								// 				$lastName: String
								// 				$company: String
								// 				$email: String
								// 				$phone: String
								// 				$address: AddressInput
								// 				$abn: Int
								// 			) {
								// 				createForm(
								// 					formName: $formName
								// 					firstName: $firstName
								// 					lastName: $lastName
								// 					company: $company
								// 					email: $email
								// 					phone: $phone
								// 					address: $address
								// 					abn: $abn
								// 				) {
								// 					_id
								// 				}
								// 			}
								//     `,
								// 	variables: {
								// 		formName: 'become-a-dealer',
								// 		firstName: values.firstName,
								// 		lastName: values.lastName,
								// 		company: values.company,
								// 		email: values.email,
								// 		phone: values.phone,
								// 		address: {
								// 			line1: values.streetAddress,
								// 			city: values.city,
								// 			state: values.state,
								// 			postalCode: values.postCode,
								// 			country: `Australia`,
								// 		},
								// 		abn: values.abn,
								// 	},
								// })
								resetForm()
								setSubmitting(false)
								return open()
							}}
						>
							{({ isSubmitting, errors, touched, values }) => (
								<StyledForm>
									{formItems.map((item, index) => {
										if (item.items) {
											const { title, items } = item
											return (
												<FormFieldGroup
													key={title + index}
													// color="#fff"
													{...{ items, errors, touched, values }}
												/>
											)
										} else {
											return (
												<FormFieldSingle
													key={item.inputName + index}
													overrideWidth="full"
													// color="#fff"
													{...{
														item: { ...item, helpText: null },
														errors,
														touched,
														values,
													}}
												/>
											)
										}
									})}
									<FieldRow>
										<FieldWrap>
											<Label htmlFor="policy">
												Policy
												<Required>*</Required>
											</Label>
											<Field name="policy" type="checkbox">
												{({ field, form: { setFieldValue, setTouched } }) => (
													<div tw="flex flex-wrap w-full items-center">
														<PolicyButton
															href="//assets.ctfassets.net/ftcnv5up9dxv/ZQoJWy8lbP7W4jNYZqqPU/c47b7f3385a11a23f4db4171764edb25/Sales_and_Advertising_Policy_Final.pdf"
															target="_blank"
														>
															Read Sales & Advertising Policy
														</PolicyButton>
														<AcceptTerms>
															<CheckboxContainer
																tw="w-6 h-6 cursor-pointer rounded-sm ml-3 mr-2"
																onClick={() =>
																	setFieldValue(
																		'policy',
																		field.checked ? false : true
																	)
																}
																onKeyDown={() =>
																	setFieldValue(
																		'policy',
																		field.checked ? false : true
																	)
																}
															>
																<CustomCheckboxInput
																	{...field}
																	checked={field.checked}
																	name="policy"
																	type="checkbox"
																/>
																<Lottie
																	playingState={'playing'}
																	speed={1}
																	direction={field.checked ? 1 : -1}
																	width={24}
																	height={24}
																	tw="bg-white rounded"
																	className="lottie-container checkbox"
																	config={{
																		animationData: animationCheckbox.default,
																		loop: false,
																		autoplay: true,
																		renderer: 'svg',
																	}}
																	aria-hidden
																/>
															</CheckboxContainer>
															Accept Policy
														</AcceptTerms>
													</div>
												)}
											</Field>
											{touched['policy'] && errors['policy'] ? (
												<StyledError>{`▲ ` + errors['policy']}</StyledError>
											) : (
												<></>
											)}
										</FieldWrap>
									</FieldRow>
									<FieldRow>
										<FieldWrap>
											<Field name="readandagree" type="checkbox">
												{({ field, form: { setFieldValue, setTouched } }) => (
													<div tw="flex w-full mb-4 items-center">
														<CheckboxContainer
															tw="w-6 h-6 cursor-pointer rounded-sm mr-2"
															onClick={() =>
																setFieldValue(
																	'readandagree',
																	field.checked ? false : true
																)
															}
															onKeyDown={() =>
																setFieldValue(
																	'readandagree',
																	field.checked ? false : true
																)
															}
														>
															<CustomCheckboxInput
																{...field}
																checked={field.checked}
																name="readandagree"
																type="checkbox"
															/>
															<Lottie
																playingState={'playing'}
																speed={1}
																direction={field.checked ? 1 : -1}
																width={24}
																height={24}
																tw="bg-white rounded"
																className="lottie-container checkbox"
																config={{
																	animationData: animationCheckbox.default,
																	loop: false,
																	autoplay: true,
																	renderer: 'svg',
																}}
																aria-hidden
															/>
														</CheckboxContainer>
														<p tw="text-sm font-display">I have read and I agree to <a tw="font-bold underline hover:no-underline" href="/terms" target="_blank">Maytronics Terms &#38; Conditions</a> and <a tw="font-bold underline hover:no-underline" href="/privacy" target="_blank">Privacy Policy</a> <Required>*</Required></p>
													</div>
												)}
											</Field>
											{touched['readandagree'] && errors['readandagree'] ? (
												<StyledError>{`▲ ` + errors['readandagree']}</StyledError>
											) : (
												<></>
											)}
										</FieldWrap>
									</FieldRow>
									<FieldRow>
										<FieldWrap>
											<Field name="updates" type="checkbox">
												{({ field, form: { setFieldValue, setTouched } }) => (
													<div tw="flex w-full mb-4 items-center">
														<CheckboxContainer
															tw="w-6 h-6 cursor-pointer rounded-sm mr-2"
															onClick={() =>
																setFieldValue(
																	'updates',
																	field.checked ? false : true
																)
															}
															onKeyDown={() =>
																setFieldValue(
																	'updates',
																	field.checked ? false : true
																)
															}
														>
															<CustomCheckboxInput
																{...field}
																checked={field.checked}
																name="updates"
																type="checkbox"
															/>
															<Lottie
																playingState={'playing'}
																speed={1}
																direction={field.checked ? 1 : -1}
																width={24}
																height={24}
																tw="bg-white rounded"
																className="lottie-container checkbox"
																config={{
																	animationData: animationCheckbox.default,
																	loop: false,
																	autoplay: true,
																	renderer: 'svg',
																}}
																aria-hidden
															/>
														</CheckboxContainer>
														<p tw="text-sm font-display">I wish to receive updates and promotions from Maytronics.</p>
													</div>
												)}
											</Field>
										</FieldWrap>
									</FieldRow>
									<HomeButtonRow>
										<HomeButton type="submit" disabled={isSubmitting}>
											Send Message
										</HomeButton>
									</HomeButtonRow>
								</StyledForm>
							)}
						</Formik>
						<PopUp showDialog={showDialog} close={close} />
					</ContactContainer>
				</ContentsContainer>
			</ContentsSection>
		</Layout>
	)
}

export const SUPPORT_DEALER_QUERY = graphql`
	query supportDealerQuery {
		page: allContentfulPage(
			filter: { contentful_id: { eq: "61RLngl5p4jXEvKThkyH8g" } }
		) {
			edges {
				node {
					seoTitle
					seoKeywords
					seoDescription
					node_locale
					slug
					body {
						json
					}
				}
			}
		}
		form: allContentfulForm(
			filter: { contentful_id: { eq: "5tzMY5nVasIixhvrDBObNF" } }
		) {
			edges {
				node {
					title
					description
					endpoint
					node_locale
					items {
						... on ContentfulFormField {
							helpText
							inputAutocomplete
							inputId
							inputName
							inputPlaceholder
							inputRequired
							inputType
							textareaCols
							textareaRows
							icon
							validationText
							width
							options
							node_locale
							label
						}
						... on ContentfulFormGroup {
							title
							items {
								width
								validationText
								textareaRows
								textareaCols
								options
								node_locale
								label
								inputType
								inputRequired
								inputPlaceholder
								inputName
								inputId
								inputAutocomplete
								icon
								helpText
							}
						}
					}
				}
			}
		}
	}
`
BecomeADealer.propTypes = {
	data: PropTypes.objectOf({
		page: PropTypes.object,
		form: PropTypes.object,
	}),
}

export default BecomeADealer
